export default __webpack_public_path__ + "static/media/truck.6289e831.png";